import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getSelectFeaturesGeometryMasking } from "../../ducks/selectFeatures/selectors";
import { setSelectFeaturesGeometryMasking } from "../../ducks/selectFeatures/selectFeatures";

export const useSelectFeaturesGeometryMasking = (): [boolean, (name?: boolean) => void] => {
  const dispatch = useDispatch();
  const value = useSelector(getSelectFeaturesGeometryMasking);

  const update = useCallback(
    (name: boolean) => {
      dispatch(setSelectFeaturesGeometryMasking(name));
    },
    [dispatch],
  );

  return [value, update];
};
